module.exports = __webpack_public_path__ + "static/media/platform-landing-logo.c44cc182.png";